import { render, staticRenderFns } from "./ScrollingSenders.vue?vue&type=template&id=0d926cb2&scoped=true&"
import script from "./ScrollingSenders.vue?vue&type=script&lang=js&"
export * from "./ScrollingSenders.vue?vue&type=script&lang=js&"
import style0 from "./ScrollingSenders.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ScrollingSenders.vue?vue&type=style&index=1&id=0d926cb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d926cb2",
  null
  
)

export default component.exports